enum VerticalAlignmentEnum {
  Top = 'TOP',
  Bottom = 'BOTTOM',
  Center = 'CENTER',
}

export default VerticalAlignmentEnum;
